import React, { useEffect, useRef, useState } from "react";
import performanceManagementService from "@services/performanceManagement.service";
import dayjs from "dayjs";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import strftime from "strftime";


function PsShareChart() {
    const chartRef = useRef(null);
    const toast = useRef(null);
    const [lines, setLines] = useState({ left1: [], left2: [], right1: [], right2: [], bottom1: [], bottom2: [] });
    const startDate = new Date(new Date() - (30 * 86400000));
    const endDate = new Date();
    const options = {
        exporting: {
            enabled: true,
            width: 1920
        },
        title: {
            text: "",
            align: 'left'
        },
        chart: {
            zoomType: "xy",
            style: {
                height: "100%"
            },
            exporting: {
                enabled: false,
            },
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            line: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3,
                    },
                },
                marker: {
                    enabled: false,
                },
            },

            series: {
                allowPointSelect: true,
                softThreshold: false,
            },
        },
        time: {
            timezoneOffset: -270,
        },
        yAxis: [
            {
                id: "left1",
                plotLines: lines["left1"],
                lineWidth: 1,
                title: {
                    enabled: false,
                }
            },
            {
                id: "left2",
                plotLines: lines["left2"],
                title: {
                    enabled: false,
                },
            },
            {
                id: "right1",
                plotLines: lines["right1"],
                lineWidth: 1,
                opposite: true,
                title: {
                    enabled: false,
                },
            },
            {
                id: "right2",
                plotLines: lines["right2"],
                lineWidth: 0,
                opposite: true,
                title: {
                    enabled: false,
                },
            },
        ],
        xAxis: [
            {
                id: "bottom1",
                type: "datetime",
                labels: {
                    style: { fontWeight: "bold" },
                    rotation: 90,
                    // format: ""
                },
                lineWidth: 1,

                plotLines: lines["bottom1"],
                title: {
                    enabled: false,
                },
            },
            {
                id: "bottom2",
                type: "datetime",
                labels: {
                    style: { fontWeight: "bold" },
                    rotation: 90,
                    // format: ""
                },
                lineWidth: 1,
                plotLines: lines["bottom2"],
                title: {
                    enabled: false,
                },
            },
        ],
        tooltip: {
            shared: false,
            crosshairs: true,
        },

        series: [

        ],
    };


    useEffect(() => {
        const tech = "Custom";
        const level = "PROVINCE";
        const start_mini = strftime("%m-%d", new Date(startDate));
        const end_mini = strftime("%m-%d", new Date(endDate));
        const date_mini = start_mini + "|" + end_mini;
        let newNode = new Set();
        let newKPI = new Set();
        newNode.add("TEHRAN");
        newKPI.add("PS_Share");
        let data = {
            "buket": "1d",
            "startDate": startDate,
            "endDate": endDate,
            "scope": level,
            "ne_list": Array.from(newNode),
            "kpi_id": Array.from(newKPI),
            "tech": tech,
            "times": [],
            "ag": false,
        };

        performanceManagementService.fetchKpiR(data).then((response) => {
            if (chartRef.current && chartRef.current.chart) {
                for (const chart_data of response.data) {

                    chartRef.current.chart.addSeries({
                        type: "line",
                        visible: true,
                        yAxis: "left1",
                        xAxis: "bottom1",
                        name: chart_data.name,
                        data: chart_data.data,
                    });
                }
            }

        });


    }, [])


    return (
        <div className="">
            <span className="font-light text-lg text-gray-700 tracking-wide">
                Rightel Analytics
            </span>

            <h5 className="text-gray-750 bg-white mt-2 mx-2">PS Share</h5>
            <HighchartsReact
                ref={chartRef}
                highcharts={Highcharts}
                options={options}
            />

        </div>
    );
}

export default PsShareChart;
